import React, { useState } from 'react';
import EditJobDetails from './edit-job-details';
import PreviewJobDetails from './preview-job-details';
import PageHeaderText from 'components/base/page-header-text';
import { ROUTE_KEYS, ROUTE_PREFIX } from 'utils/constants';
import { Breadcrumbs } from '@cokitchen/cokitchen-components';
import useNewCareerPositionContext from 'contexts/career-position.context';
import { useLocation } from 'react-router-dom';

const JobDetails = () => {
  const { selectedJob, loadingJob } = useNewCareerPositionContext();
  const [editing, setEditing] = useState(
    new URLSearchParams(useLocation().search).get('edit') === 'true'
  );

  const roleName = selectedJob?.role;
  const breadcrumbs = [
    { name: 'Overview', path: `${ROUTE_PREFIX.FOOD}/${ROUTE_KEYS.OVERVIEW}` },
    { name: 'Career', path: ROUTE_KEYS.CAREER },
    {
      name: `${roleName}`,
      path: ''
    }
  ];

  return (
    <div>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <PageHeaderText
        title={roleName ?? 'Career'}
        description={`Update ${roleName ?? 'Career'} details here`}>
        {!editing && (
          <button
            className='border border-[#E7E8E9] shadow text-[#5C5F64] w-[86px] h-[40px] py-2 rounded-[8px]'
            onClick={() => {
              setEditing(true);
            }}>
            Edit
          </button>
        )}
      </PageHeaderText>
      {loadingJob ? (
        <div className='animate-bounce mt-28 grid place-items-center font-medium text-red-5'>
          Loading...
        </div>
      ) : (
        <>
          {editing ? (
            <EditJobDetails onEditComplete={() => setEditing(false)} />
          ) : (
            <PreviewJobDetails />
          )}
        </>
      )}
    </div>
  );
};

export default JobDetails;
